import React from 'react';

function ComptabilitePage() {
  return (
    <div style={{ padding: 24 }}>
      <h1>Comptabilité</h1>
      <p>Page `fhc-comptabilite.html` convertie en composant React.</p>
    </div>
  );
}

export default ComptabilitePage;
